/**
 * @FileUploadHelper
 * - static class to assist in validating uploaded files
 * - used as a helper for @JUNOFileUpload
 * - add file validation and upload helper methods here as needed
 * 
 ************************* Methods *******************************

 * ? validateFileAttributes takes a file: File and returns a FileUploadValidationResults object
  - let validationResults = FileUploadHelper.validateFileAttributes(file);


 */
export interface FileUploadValidationResults {
  filename: string;
  isvalid: boolean;
  message: string;
}

export default class FileUploadHelper {
  public static validateFileAttributes(aFile: File): FileUploadValidationResults {
    let validationResults = this._runFileValidations(aFile);

    if (!validationResults.isvalid) {
      let confirmTitle = '';
      let confirmMessage = '';

      switch (validationResults.message) {
        case 'file-not-found':
          confirmTitle = 'Invalid File';
          confirmMessage = HGEN.tree({
            style: '',
            interior: CrowdHub_App.LANG.FILE_UPLOAD_ERROR_FILENOTFOUND,
          });
          break;
        case 'invalid-file-type':
          confirmTitle = 'Invalid File Type';
          confirmMessage = HGEN.tree({
            style: '',
            interior: CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILETYPE.replace('*|TYPE|*', aFile.type),
          });
          break;
        case 'invalid-file-size':
          confirmTitle = 'Invalid File Size';
          confirmMessage = HGEN.tree({
            style: '',
            interior: CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILESIZE,
          });
          break;
        case 'invalid-name-spaces':
          confirmTitle = 'Invalid File Name - Spaces';
          confirmMessage = HGEN.tree({
            style: '',
            interior: CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILENAMESPACES,
          });
          break;
        case 'invalid-name-characters':
          confirmTitle = 'Invalid File Name - Characters';
          confirmMessage = HGEN.tree({
            style: '',
            interior: CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILENAMECHARACTERS,
          });
          break;
        case 'invalid-name-length':
          confirmTitle = 'Invalid File Name - Length';
          confirmMessage = HGEN.tree({
            style: '',
            interior: CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILENAMELENGTH,
          });
          break;
      }
      let confirmPopup = new ConfirmPopupPanel();
      confirmPopup.showOkConfirm(confirmTitle, confirmMessage, () => {
        // TODO something after they acknowledge error?
      });
    }

    return validationResults;
  }

  private static _runFileValidations(aFile: File): FileUploadValidationResults {
    let validationResults = {
      isvalid: false,
      filename: '',
      message: '',
    };
    if (!aFile || aFile.size == 0) {
      validationResults.message = 'file-not-found';
      return validationResults;
    }

    let re = /(?:\.([^.]+))?$/;
    let fileNameExt = re.exec(aFile.name)[1];
    let hasFileType = false;

    CrowdHub_App.CONFIG.ALLOWED_FILE_TYPES.forEach(fileTypeArray => {
      if (fileTypeArray.indexOf(fileNameExt) >= 0) {
        hasFileType = true;
      }
    });

    if (!hasFileType) {
      validationResults.message = 'invalid-file-type';
      return validationResults;
    }

    if (aFile.size > CrowdHub_App.CONFIG.MAX_FILE_UPLOAD_SIZE_IN_BYTES) {
      validationResults.message = 'invalid-file-size';
      return validationResults;
    }

    // spaces
    if (aFile.name.search(' ') !== -1) {
      validationResults.message = 'invalid-name-spaces';
      return validationResults;
    }

    // special characters
    const specialChars = /[`!@#$%^&*()+\=\[\]{};':"\\|,<>\/?~]/;
    if (specialChars.test(aFile.name)) {
      validationResults.message = 'invalid-name-characters';
      return validationResults;
    }

    if (aFile.name.length == 0 || aFile.name.length > 100) {
      validationResults.message = 'invalid-name-length';
      return validationResults;
    }

    validationResults.filename = aFile.name;
    validationResults.isvalid = true;
    return validationResults;
  }
}
